import jQuery from 'jquery'
// import axios from 'axios'

export default {
  auth: (ctx) => {
    return new Promise((resolve, reject) => {
      let url = window.API_URL + 'auth.api'
      let json = JSON.stringify(ctx, null, 2)
      console.debug('■called:' + url + '\n' + json)
      jQuery.ajax({
        url: url,
        type: 'POST',
        data: json,
        xhrFields: {
          withCredentials: true
        },
        error: (XMLHttpRequest, textStatus, err) => {
          reject(new Error(err.response.data.message || err.message))
        },
        success: ctx => {
          console.debug(JSON.stringify(ctx.data, null, 2))
          resolve(ctx.data)
        }
      })
    })
  },
  getData: (api, params) => {
    return new Promise((resolve, reject) => {
      let url = window.API_URL + 'data.api?api=' + api
      if (params) {
        params.forEach(function (val, key) {
          url = url + key + '=' + val
        })
      }
      jQuery.ajax({
        url: url,
        dataType: 'jsonp',
        xhrFields: {
          withCredentials: true
        },
        error: (XMLHttpRequest, textStatus, err) => {
          reject(new Error(err.response.data.message || err.message))
        },
        success: res => {
          let output = res.data[''].output
          console.debug(res.data)
          resolve(output)
        }
      })
    })
  },
  postData: (ctx) => {
    return new Promise((resolve, reject) => {
      let url = window.API_URL + 'data.api'
      let json = JSON.stringify(ctx, null, 2)
      console.debug('■called:' + url + '\n' + json)
      jQuery.ajax({
        url: url,
        type: 'POST',
        data: json,
        xhrFields: {
          withCredentials: true
        },
        error: (XMLHttpRequest, textStatus, err) => {
          reject(new Error(err.response.data.message || err.message))
        },
        success: ctx => {
          console.debug(JSON.stringify(ctx.data, null, 2))
          resolve(ctx.data)
        }
      })
    })
  },
  download: (ctx) => {
    return new Promise((resolve, reject) => {
      let url = window.API_URL + 'download.api'
      try {
        let sendForm = document.createElement('form')
        sendForm.action = url
        sendForm.method = 'POST'
        sendForm.style.visibility = 'hidden' // 画面に表示しない
        sendForm.target = 'download'
        document.body.appendChild(sendForm) // 画面内に追加

        let fld1 = document.createElement('input')
        fld1.name = 'data'
        fld1.type = 'hidden'
        fld1.value = JSON.stringify(ctx)
        sendForm.appendChild(fld1)
        sendForm.submit()
      } catch (ex) {
        throw ex
      }
    })
  },
  getApi: (uri) => {
    const url = window.API_URL + uri
    console.debug('■called getApi:' + url)
    return new Promise(resolve => {
      jQuery.get(url, function (data) {
        resolve(data.data[''].output)
      })
      // axios.get(url).then(response => {
      // resolve(response.data.data[''].output)
      // })
    })
  }

}



// WEBPACK FOOTER //
// ./src/base/api/client.js